// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.content[data-v-9ba8054c] {\r\n\tfont-size: 15px;\n}\n.gray[data-v-9ba8054c] {\r\n\tcolor: var(--main-gray-5);\n}\n.product[data-v-9ba8054c] { font-size: 18px;\n}\n.total[data-v-9ba8054c] { font-size: 18px; font-weight: bold; color: var(--main-blue-3); width: 100%;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
